import React, { useState } from 'react';
import { useFeathers } from '../../app/util';
import { ReactComponent as GreenCheckSvg } from '../../images/green-check.svg';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import useKeypress from "react-use-keypress";
import { DistrictSelectInput } from '../DistrictSelectInput';

const SendInvitationModal = ( { invitationUser = null, refreshUsers, auditorMode = false }) => {
  const feathers = useFeathers()
  const [ userEmail, setUserEmail ] = useState(invitationUser?.email || '')
  const [ userPermission, setUserPermission ] = useState(
    invitationUser?.permissions?.[0] || (auditorMode ? 'auditor' : 'researcher')
  )
  const [ sending, setSending ] = useState(false)
  const [ sent, setSent ] = useState(false)
  const [ error, setError ] = useState('');
  const [ limitedStates, setLimitedStates ] = useState([]);
  const submittable = userEmail?.length > 5;



  const sendInvitation = async() => {
    if(!submittable) return;
    try {
      setSending(true)
      await feathers.getService('invite-links').create({
        email: userEmail,
        starterPermissions: [ userPermission ],
        ...(auditorMode ? { limitAccessToStates: limitedStates.map(state => state._id || state) } : {})
      })
      setSending(false)
      setSent(true)
      refreshUsers()
    } catch (err) {
      setError(err.message )
    }
  }

  const handlePermissionsChange = (e) => {
    setUserPermission(e.target.value)
  }



  const reset = () => {
    setUserEmail('')
    setUserPermission(auditorMode ? 'auditor' : 'researcher')
    setError('')
    setSent(false)
    setLimitedStates([])
  }

  useKeypress('Enter', () => {
    if(submittable && !sending && !sent) sendInvitation()
    if(sent) reset()
  });

  if(sent) {
    return (
      <SendInvitationWrapper>
        <SavedWrapper>
          <GreenCheck/>
          <Typography>Invitation sent to { userEmail }!</Typography>
        </SavedWrapper>
        {
          !invitationUser &&
          <Button onClick={reset} variant={'contained'} color={'primary'}>
            Send another
          </Button>
        }
      </SendInvitationWrapper>
    )
  }

  return (
    <>
        <SendInvitationWrapper>
          <Typography variant="h4">{invitationUser ? 'Resend Invite' :'Invite User'}</Typography>
          <InvitationDetailsWrapper>
            {
              !invitationUser
              ?
              <>
                <Typography style={{ paddingTop: '4px' }}>Email</Typography>
                <TextField
                  label='Email'
                  value={ userEmail }
                  onChange={ (e) => setUserEmail(e.target.value) }
                  size="small"
                  fullWidth
                />
                {!auditorMode && (
                  <>
                    <Typography style={{ paddingTop: '4px' }}>Access Level</Typography>
                    <TextField
                      select
                      fullWidth
                      value={userPermission}
                      onChange={handlePermissionsChange}
                      variant="outlined"
                      size="small"
                    >
                      <MenuItem value="researcher">Researcher</MenuItem>
                      <MenuItem value="reviewer">Reviewer</MenuItem>
                      <MenuItem value="editor">Editor</MenuItem>
                      <MenuItem value="publisher">Publisher</MenuItem>
                    </TextField>
                  </>
                )}
                {auditorMode && (
                  <>
                    <Typography style={{ marginTop: '12px' }}>Limit Access to States</Typography>
                    <DistrictSelectInput
                      value={limitedStates}
                      onChange={e => setLimitedStates(e.target.value)}
                      districtTypes={['state']}
                      multi={true}
                      style={{ marginTop: '12px', width: '100%' }}
                    />
                  </>
                )}
              </>
              :
              <>
                <Typography style={{ paddingTop: '4px' }}>Email</Typography>
                <Typography>{userEmail}</Typography>
                <Typography style={{ paddingTop: '4px' }}>Access Level</Typography>
                <Typography>{userPermission}</Typography>
                {auditorMode && limitedStates.length > 0 && (
                  <>
                    <Typography style={{ paddingTop: '4px' }}>Limited states</Typography>
                    <Typography>{`${limitedStates.length} state(s)`}</Typography>
                  </>
                )}
              </>
            }
          </InvitationDetailsWrapper>
          {
            !sending
              ?
              <Button
                  variant={'contained'}
                  color={'primary'}
                  disabled={!submittable || sending}
                  onClick={sendInvitation}
                >Send Invitation
              </Button>
              :
              <Typography style={{color: error ? 'red' : '' }}>
                {error ? error : 'Sending....'}
              </Typography>
          }
        </SendInvitationWrapper>

    </>
  )
}

const SendInvitationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 60px;
  justify-content: space-between;
  gap: 24px;
  min-width: 320px;
  width: 420px;

  .MuiTypography-h2 {
    font-size: 22px;
    line-height: 1.2;
  }

  .MuiInput-root {
    border-bottom: 1px solid #22034F !important;
    color: #313639
  }
`

const InvitationDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-column-gap: 24px;
  grid-row-gap: 16px;
`

const GreenCheck = styled(GreenCheckSvg)`
  width: 25px;
  height: auto;
`

const SavedWrapper = styled.div`
  display: flex;
  gap: 10%;
  justify-content: center;
  align-items: center;
`

  export default SendInvitationModal;
